var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-alert-wrapper", class: _setup.alert.class },
    [
      !_vm.$slots.default
        ? [
            _setup.alert.icon.length
              ? _c("font-awesome-icon", {
                  staticClass: "mr-2",
                  attrs: { icon: _setup.alert.icon },
                })
              : _vm._e(),
            _vm._v("\n        " + _vm._s(_vm.text) + "\n    "),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }